<template>
    <div class="am-accountform-page" :style="{ '--am-accent': amSubjectTheme.accent }" style="width: 100vw;height: 100vh;background-color: #FF8C00;overflow-y: auto;font-family: GravityNormal">
        <div class="accountform">
            <div style="display: flex;width: 100%;align-items: flex-start;">
                <div style="display: flex;flex: 1;align-items: flex-start;">
                    <img src="../../assets/image/logo.png" style="width: 240px;height: auto; margin-right: 32px" />
                    <img src="../../assets/image/am_logo.png" style="width: 110px;height: auto;object-fit: cover;margin-top: -15px;" />
                </div>
                <p style="width: 300px;font-size: 12px;text-align: right;color: #666;line-height: 20px;">
                    Extracurricular Activity Excellence (EAE) International</p>
            </div>
            <div class="title1">Organization Registration{{ selectedProject && selectedProject.project_ename ? ' for ' + selectedProject.project_ename : (form.project_code ? ' for ' + form.project_code : '') }}</div>
            <div class="title1" style="font-size: 12px;margin-top: 5px;">please fill out this form in English</div>
            <div style="color: #ff0000; font-size: 14px; margin: 20px 0; text-align: center; width: 100%; padding: 10px; background-color: #ffe6e6; border-radius: 4px;">
                This registration form is only for ADVISERS/TEACHERS to register for their organizations. <br>If you are <strong>an individual STUDENT or a STUDENT team leader</strong>, please use the<a href="/#/form/am" style="color: #ff0000; text-decoration: underline;"> Student Registration Form</a> instead.
            </div>
            <el-form :model="form" :rules="formRules" ref="form"
                style="width: 100%;padding: 0px 20px;box-sizing: border-box;" label-position="top">

                <p style="text-align: left;color: #2C3E50; font-size: 16px; font-weight: bold;margin: 20px 0px;">
                    Project Selection</p>

                <div class="row project-selection-row">
                    <div class="item">
                        <el-form-item label="Select Project" prop="project_code">
                            <el-select v-model="form.project_code" style="width: 100%;" placeholder="Please select a project"
                                @change="handleProjectChanged">
                                <el-option v-for="(project, index) in projectList" :key="index"
                                    :value="project.project_code">
                                    <span>{{ project.project_ename || project.project_code }}</span>
                                    <span v-if="project.deadline_date" style="color: #999; font-size: 12px; margin-left: 10px;">
                                        (Registration deadline: {{ formatDeadline(project.deadline_date) }})
                                    </span>
                                </el-option>
                            </el-select>
                            <p style="color: #666;font-size: 12px;line-height: 16px;margin-top: 10px;">Please select the AM project you wish to register for.</p>
                        </el-form-item>
                    </div>
                </div>

                <div class="row participation-arrangement-row">
                    <div class="item participation-arrangement-item">
                        <el-form-item label="Participation arrangement" prop="participation_arrangement">
                            <el-radio-group v-model="form.participation_arrangement" class="participation-radio-group">
                                <el-radio label="School day" class="participation-radio-option">
                                    {{ getParticipationArrangementLabel('School day') }}
                                </el-radio>
                                <el-radio label="Standard registration" class="participation-radio-option">
                                    {{ getParticipationArrangementLabel('Standard registration') }}
                                </el-radio>
                            </el-radio-group>
                            <p style="color: #666;font-size: 12px;line-height: 16px;margin-top: 10px;">{{ participationArrangementHelpText }}</p>
                        </el-form-item>
                    </div>
                </div>
                <p style="text-align: left;color: #2C3E50; font-size: 16px; font-weight: bold;margin: 20px 0px;">
                    Registrant Information</p>

                    <div class="row">
                        <div class="item">
                        <el-form-item>
                            <el-form-item label="First Name (in English)" prop="contact_givenName">
                                <el-input v-model="form.contact_givenName" placeholder="Please input"></el-input>
                            </el-form-item>
                        </el-form-item>
                    </div>
                    <div class="item">
                        <el-form-item>
                            <el-form-item label="Last Name (in English)" prop="contact_lastName">
                                <el-input v-model="form.contact_lastName" placeholder="Please input"></el-input>
                            </el-form-item>
                        </el-form-item>
                    </div>
                </div>

                <div class="row">
                    <div class="item">
                        <el-form-item>
                            <el-form-item label="Position" prop="contact_position">
                                <el-input v-model="form.contact_position" placeholder="Please input"></el-input>
                            </el-form-item>
                        </el-form-item>
                    </div>
                    <div class="item">
                        <el-form-item>
                            <el-form-item label="Email" prop="contact_email">
                                <el-input v-model="form.contact_email" placeholder="Please input"></el-input>
                            </el-form-item>
                        </el-form-item>
                    </div>
                </div>


                <div class="row">
                    <div class="item">
                        <el-form-item label="Gender" prop="contact_prefix">
                            <el-select v-model="form.contact_prefix" style="width: 100%;">
                                <el-option value="Male" label="Male"></el-option>
                                <el-option value="Female" label="Female"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="item">
                        <el-form-item label="How do you learn about us" prop="know_sources">
                            <el-select v-model="form.know_sources" style="width: 100%;">
                                <el-option value="Previous projects" label="Previous projects"></el-option>
                                <el-option value="Recommendation by others"
                                    label="Recommendation by others"></el-option>
                                <el-option value="Student inquiries" label="Student inquiries"></el-option>
                                <el-option value="Web browsing" label="Web browsing"></el-option>
                                <el-option value="Search results" label="Search results"></el-option>
                                <el-option value="Proactive email" label="Proactive email"></el-option>
                                <el-option value="Others" label="Others"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>

                <p style="text-align: left;color: #2C3E50; font-size: 16px; font-weight: bold;margin: 20px 0px;">
                    Organization Information</p>
                <div class="row">
                    <div class="item">
                        <el-form-item label="Organization Name" prop="account_nameEn">
                            <el-input v-model="form.account_nameEn" placeholder="Please input"></el-input>
                        </el-form-item>
                    </div>
                    <div class="item">
                        <el-form-item label="Organization Type" prop="organization_type">
                            <el-select v-model="form.organization_type" style="width: 100%;">
                                <el-option value="Secondary School" label="Secondary School"></el-option>
                                <el-option value="Study Abroad Agency" label="Study Abroad Agency"></el-option>
                                <el-option value="Admission Consultant/Firm"
                                    label="Admission Consultant/Firm"></el-option>
                                <el-option value="Academic Enrichment Center"
                                    label="Academic Enrichment Center"></el-option>
                                <el-option value="Other" label="Other"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>

                <div class="row" v-if="form.organization_type == 'Secondary School'">
                    <div class="item">
                        <el-form-item label="Curriculum type" prop="curriculum_types">
                            <div style="display: flex;">
                                <el-select v-model="form.curriculum_types" multiple="true">
                                    <el-option value="AP" label="AP"></el-option>
                                    <el-option value="BC/OSSD" label="BC/OSSD"></el-option>
                                    <el-option value="Blended Learning Center"
                                        label="Blended Learning Center"></el-option>
                                    <el-option value="IBDP" label="IBDP"></el-option>
                                    <el-option value="IGCSE or Alevel" label="IGCSE or Alevel"></el-option>
                                    <el-option value="PGA" label="PGA"></el-option>
                                    <el-option value="General high school" label="General high school"></el-option>
                                    <el-option value="Others" label="Others"></el-option>
                                </el-select>
                                <el-input v-if="checkShowOthersView()" v-model="form.other_curriculum_type" placeholder="Please input"
                                    style="width: 50%"></el-input>
                            </div>
                        </el-form-item>
                    </div>
                </div>

                <div class="row">
                    <div class="item">
                        <el-form-item label="Annual Tuition" prop="annual_tuition">
                            <el-select v-model="form.annual_tuition" placeholder="Please select" style="width: 100%;">
                                <el-option value="> 11,000 USD">> 11,000 USD</el-option>
                                <el-option value="> 6,000 USD">> 6,000 USD</el-option>
                                <el-option value="> 3,000 USD">> 3,000 USD</el-option>
                                <el-option value="> 1,500 USD">> 1,500 USD</el-option>
                                <el-option value="> 1,100 USD">> 1,100 USD</el-option>
                                <el-option value="> 750 USD">> 750 USD</el-option>
                                <el-option value="> 350 USD">> 350 USD</el-option>
                                <el-option value="< 350 USD and > 0">< 350 USD and > 0</el-option>
                                <el-option value="Free">Free</el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="item">
                        <el-form-item label="School's Student Size" prop="student_size">
                            <el-select v-model="form.student_size" placeholder="Please select" style="width: 100%;">
                                <el-option value="0-50 students" label="0-50 students"></el-option>
                                <el-option value="50-100 students" label="50-100 students"></el-option>
                                <el-option value="100-200 students" label="100-200 students"></el-option>
                                <el-option value="200-500 students" label="200-500 students"></el-option>
                                <el-option value="500-1000 students" label="500-1000 students"></el-option>
                                <el-option value="1000-2000 students" label="1000-2000 students"></el-option>
                                <el-option value="above 2000 students" label="Above 2000 students"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>



                <div class="row">
                    <div class="item">
                        <el-form-item prop="account_country">
                            <template slot="label">
                                <span>Country/Region</span>
                                <el-tooltip effect="dark" placement="top" trigger="click" content="Select your school's country/region, regardless of your citizenship. For international students, this means your current school location. Registration levels are based on school location only.">
                                    <i class="el-icon-info" style="margin-left: 5px; color: #409EFF; cursor: pointer;"></i>
                                </el-tooltip>
                            </template>
                            <div>
                                <el-select v-model="form.account_country" style="width: 100%;" placeholder="Please select"  filterable @change="handleCountryChanged">
                                    <el-option v-for="(country, index) in countryList" :key="index"
                                        :label="country.country_en" :value="country.country_en"></el-option>
                                </el-select>
                                <p style="color: #666;font-size: 12px;line-height: 16px;margin-top: 10px;">Select your school's country/region, regardless of your citizenship. For international students, this means your current school location. Registration levels are based on school location only.</p>
                            </div>
                        </el-form-item>
                    </div>
                    <div class="item">
                        <el-form-item label="State/Province" prop="account_province">
                            <el-input v-model="form.account_province" placeholder="Please input"></el-input>
                        </el-form-item>
                    </div>
                </div>

                <div class="row">
                    <div class="item">
                        <el-form-item label="Website" prop="account_website">
                            <el-input v-model="form.account_website" placeholder="Please input"></el-input>
                        </el-form-item>
                    </div>
                    <div class="item">
                        <el-form-item label=" Address" prop="account_address">
                            <el-input v-model="form.account_address" placeholder="Please input"></el-input>
                        </el-form-item>
                    </div>
                </div>

                <p style="text-align: left;color: #2C3E50; font-size: 16px; font-weight: bold;margin: 20px 0px;">
                    Advisor Information</p>

                <el-form-item label="Will you be the advisor for the AM Program in your school/institution?" prop="contact_as_adviser">
                    <el-radio v-model="form.contact_as_adviser" label="YES"></el-radio>
                    <el-radio v-model="form.contact_as_adviser" label="NO" style="margin-left: 100px;"></el-radio>
                </el-form-item>

                <template v-if="form.contact_as_adviser === 'NO'">
                    <p style="color: #666; font-size: 14px; line-height: 20px; margin-bottom: 20px;">If you are not the advisor for AM Program, please provide the information of the right advisor.</p>
                    <div class="row">
                        <div class="item">
                            <el-form-item label="Advisor's First Name" style="flex: 1;" prop="adviser_givenName">
                                <el-input v-model="form.adviser_givenName" placeholder="Please input"></el-input>
                            </el-form-item>
                        </div>
                        <div class="item">
                            <el-form-item label="Advisor's Last Name" style="flex: 1;" prop="adviser_lastName">
                                <el-input v-model="form.adviser_lastName" placeholder="Please input"></el-input>
                            </el-form-item>
                        </div>
                    </div>

                    <div class="row">
                        <div class="item">
                            <el-form-item label="Advisor's Position/Subject" style="flex: 1;" prop="adviser_subject">
                                <el-input v-model="form.adviser_subject" placeholder="Please input"></el-input>
                            </el-form-item>
                        </div>
                        <div class="item">
                            <el-form-item label="Advisor's Email" style="flex: 1;" prop="adviser_email">
                                <el-input v-model="form.adviser_email" placeholder="Please input"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                </template>
            </el-form>

            <div class="terms flex items-center justify-center" style="margin-top: 20px;">
                <div @click="isAgree = !isAgree" style="display: flex; align-items: center">
                    <img style="width: 16px;height: 16px;cursor: pointer;margin-right: 16px;" v-if="!isAgree"
                        :src="require('../../assets/image/unchecked.png')" />
                    <img style="width: 16px;height: 16px;cursor: pointer;margin-right: 16px;" v-else
                        :src="require('../../assets/image/checked.png')" />
                </div>
                <p style="line-height: 20px;"> I have read and agree to the <a href="#/privacy-policy" target="_blank" rel="noopener noreferrer" style="color: #409EFF; text-decoration: underline;" @click.stop>Privacy Policy</a>, and I agree that EAE may use my provided information to set up a personal account and to email me about notifications, reminders, and extracurricular opportunities.</p>
            </div>

            <div v-if="selectedProject && isDeadlinePassed()" style="color: #2C3E50; font-size: 16px; font-weight: bold;margin: 20px 0px;text-align: center;">
                The registration deadline has passed.<br>
                <span style="font-size: 12px;color: #666;">The registration deadline is {{selectedProject.deadline_string}} in your local time.</span>
            </div>
            <div v-else-if="!form.project_code" style="color: #2C3E50; font-size: 16px; font-weight: bold;margin: 20px 0px;text-align: center; padding: 20px; background-color: #E8ECF1; border-radius: 8px; border: 2px solid #2C3E50;">
                Please select a project to continue.
            </div>
            <div v-else class="submit">
                <div class="submitBtn" @click="submit">Submit</div>
            </div>
        </div>
        <AccountFormConfirmDialog
            :show.sync="showConfirmDialog"
            :email="form.contact_email"
            :highlightFields="confirmHighlightFields"
            :normalFields="confirmNormalFields"
            :themeColor="'#D3A12A'"
            @confirmed="doSubmit"
        />
    </div>
</template>
<script>
import {
    getCountries,
    saveAccountFormV1,
    postRequest,
    getExclusivePartners,
    getFutureOpenProjects
} from '../../api/eae'
import AccountFormConfirmDialog from '../../components/AccountFormConfirmDialog.vue'
import { checkAndConfirmName } from '../../utils/nameValidator'
import { resolveAmSubjectTheme } from '../../utils/amSubjectTheme'
import '../../assets/common/font.css'

const PARTICIPATION_ARRANGEMENT_LABELS = {
    'School day': 'School-branded Academic Marathon with authorization',
    'Standard registration': 'Student Independent Registration Coordinated by School'
}

export default ({
    name: 'index',
    components: { AccountFormConfirmDialog },
    data() {
        return {

            showConfirmDialog: false,
            isAgree: false,

            countryList: [],
            exclusivePartners: [],
            projectList: [],
            selectedProject: null,

            currentYear: '',
            form: {
                BU: "AM",
                project_code: '',
                new_field: 'yes',
                participation_arrangement: '',
                institution_terms_agreed: 'NO',
                account_website:'',
                account_country: '',
                account_name: '',
                account_nameEn: '',
                account_province: '',
                account_address: '',
                organization_type: '',

                curriculum_types: [],
                other_curriculum_type: '',
                annual_tuition: '',
                student_size: '',

                contact_lastName: '',
                contact_givenName: '',
                contact_prefix: '',
                contact_email: '',
                contact_position: '',

                know_sources: [],
                contact_as_adviser: '',

                adviser_lastName: '',
                adviser_givenName: '',
                adviser_subject: '',
                adviser_email: '',
            },
            formRules: {
                project_code: [
                    { required: true, message: "Please select a project", trigger: "blur" },
                ],
                participation_arrangement: [
                    { required: true, message: "Please select", trigger: "change" },
                ],
                account_website: [{ required: true, message: "Please input", trigger: "blur" }],
                annual_tuition: [{ required: true, message: "Please select", trigger: "blur" }],
                curriculum_types: [
                    { required: true, message: "Please select", trigger: "blur" },
                ],
                know_sources: [{ required: true, message: "Please select", trigger: "blur" }],
                contact_lastName: [{ required: true, message: "Please input", trigger: "blur" }],
                contact_givenName: [{ required: true, message: "Please input", trigger: "blur" }],
                contact_prefix: [{ required: true, message: "Please select", trigger: "blur" }],
                contact_email: [
                    { required: true, message: "Please input", trigger: "blur" },
                    { type: 'email', message: "Please enter a valid email address", trigger: "blur" }
                ],
                contact_position: [{ required: true, message: "Please input", trigger: "blur" }],

                account_nameEn: [{ required: true, message: "Please input", trigger: "blur" }],
                organization_type: [{ required: true, message: "Please select", trigger: "blur" }],
                account_country: [{ required: true, message: "Please select", trigger: "blur" }],
                account_province: [{ required: true, message: "Please input", trigger: "blur" }],

                contact_as_adviser: [{ required: true, message: "Please select", trigger: "blur" }],
                adviser_givenName: [{ 
                    required: true, 
                    message: "Please input", 
                    trigger: "blur",
                    validator: (rule, value, callback) => {
                        if (this.form.contact_as_adviser === 'NO' && !value) {
                            callback(new Error('Please input'));
                        } else {
                            callback();
                        }
                    }
                }],
                adviser_lastName: [{ 
                    required: true, 
                    message: "Please input", 
                    trigger: "blur",
                    validator: (rule, value, callback) => {
                        if (this.form.contact_as_adviser === 'NO' && !value) {
                            callback(new Error('Please input'));
                        } else {
                            callback();
                        }
                    }
                }],
                adviser_subject: [{ 
                    required: true, 
                    message: "Please input", 
                    trigger: "blur",
                    validator: (rule, value, callback) => {
                        if (this.form.contact_as_adviser === 'NO' && !value) {
                            callback(new Error('Please input'));
                        } else {
                            callback();
                        }
                    }
                }],
                adviser_email: [
                    { 
                        required: true, 
                        message: "Please input", 
                        trigger: "blur",
                        validator: (rule, value, callback) => {
                            if (this.form.contact_as_adviser === 'NO' && !value) {
                                callback(new Error('Please input'));
                            } else {
                                callback();
                            }
                        }
                    },
                    { type: 'email', message: "Please enter a valid email address", trigger: "blur" }
                ],
                student_size: [
                    { required: true, message: "Please select", trigger: "change" }
                ],
            }
        }
    },
    computed: {
        amSubjectTheme() {
            return resolveAmSubjectTheme(
                this.form.project_code,
                (this.selectedProject && this.selectedProject.project_ename) || 'Academic Marathon'
            )
        },
        confirmHighlightFields() {
            return [
                { label: 'Name', value: (this.form.contact_givenName + ' ' + this.form.contact_lastName).trim() },
                { label: 'Email', value: this.form.contact_email },
                { label: 'Country/Region', value: this.form.account_country }
            ].filter(f => f.value)
        },
        confirmNormalFields() {
            return [
                { label: 'Organization', value: this.form.account_nameEn },
                { label: 'Organization Type', value: this.form.organization_type },
                { label: 'Participation Arrangement', value: this.getParticipationArrangementLabel(this.form.participation_arrangement) },
                { label: 'Position', value: this.form.contact_position },
                { label: 'State/Province', value: this.form.account_province },
                { label: 'Website', value: this.form.account_website },
            ].filter(f => f.value)
        },
        participationArrangementHelpText() {
            if (this.form.participation_arrangement === 'Standard registration') {
                return 'Students register and pay individually. Your school is not invoiced, and students take part in the official competition window.'
            }
            if (this.form.participation_arrangement === 'School day') {
                return 'Your school coordinates participation and pays on behalf of its students, and runs the marathon at a date and time of its choosing.'
            }
            return 'Choose whether students register individually or your school runs a school-branded Academic Marathon.'
        }
    },
    mounted() {
        let date = new Date()
        let year = date.getFullYear()
        let currentMonth = date.getMonth() + 1
        if (currentMonth >= 9) {
            this.currentYear = year
        } else {
            this.currentYear = year - 1
        }
        this.fetchProjects()
        this.requestCounties()
    },
    methods: {
        getParticipationArrangementLabel(value) {
            return PARTICIPATION_ARRANGEMENT_LABELS[value] || value
        },
        fetchProjects() {
            const startOfToday = new Date()
            startOfToday.setHours(0, 0, 0, 0)
            const registrationYear = this.currentYear + 1
            const filters = {
                open_status: 'YES',
                project_BU: 'AM',
                deadline_date: { $gte: startOfToday.getTime() }
            }
            getFutureOpenProjects(filters).then((res) => {
                console.log('getFutureOpenProjects response:', res)
                if (res && res.data) {
                    // Handle different response structures
                    if (Array.isArray(res.data)) {
                        // Direct array response
                        this.projectList = res.data.filter(project => String(project.project_code || '').startsWith(String(registrationYear)))
                    } else if (res.data.code === 0 && res.data.data) {
                        // Standard structure: {code: 0, data: [...]}
                        this.projectList = Array.isArray(res.data.data)
                            ? res.data.data.filter(project => String(project.project_code || '').startsWith(String(registrationYear)))
                            : []
                    } else if (res.data.data && Array.isArray(res.data.data)) {
                        // Nested data structure without code check
                        this.projectList = res.data.data.filter(project => String(project.project_code || '').startsWith(String(registrationYear)))
                    } else {
                        console.error('Unexpected response structure:', res.data)
                        this.$message.error('Failed to load projects: Unexpected response format')
                        this.projectList = []
                    }
                    console.log('Project list populated:', this.projectList)
                } else {
                    console.error('No data in response:', res)
                    this.$message.error('Failed to load projects: No data received')
                    this.projectList = []
                }
            }).catch((err) => {
                console.error('Error fetching projects:', err)
                this.$message.error('Failed to load projects')
                this.projectList = []
            })
        },
        handleProjectChanged() {
            this.form.participation_arrangement = ''
            this.selectedProject = this.projectList.find(project => project.project_code === this.form.project_code) || null
            if (this.form.project_code) {
                this.getProjectInfo()
                this.fetchExclusivePartners()
            }
        },
        formatDeadline(deadlineDate) {
            if (!deadlineDate) return ''
            // Handle both timestamp (milliseconds) and Date objects
            const date = typeof deadlineDate === 'number' ? new Date(deadlineDate) : new Date(deadlineDate)
            if (isNaN(date.getTime())) return ''
            
            // Format as YYYY-MM-DD
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            return `${year}-${month}-${day}`
        },
        isDeadlinePassed() {
            if (!this.selectedProject || !this.selectedProject.deadline_date) {
                return false;
            }
            const currentDate = new Date();
            const deadlineDate = new Date(this.selectedProject.deadline_date);
            // Compare dates (year, month, day) only
            const currentDateOnly = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
            const deadlineDateOnly = new Date(deadlineDate.getFullYear(), deadlineDate.getMonth(), deadlineDate.getDate());
            return currentDateOnly > deadlineDateOnly;
        },
        getProjectInfo(){
            postRequest({
                function: 'getProjectInfoByCode',
                project_code: this.form.project_code
            }).then((res) => {
                if (res.data) {
                    this.selectedProject = res.data
                    // Add 23:59:59 to deadline date
                    let deadlineDate =  new Date(this.selectedProject.deadline_date) 
                    
                    deadlineDate.setHours(23, 59, 59)
                    
                    
                    // Convert to UTC+8 time string
                    let utc8Date = new Date(deadlineDate.getTime())
                    let utc8String = utc8Date.toLocaleString('en-US', { timeZone: 'Asia/Shanghai' })
                    console.log('3'+utc8String)
                    
                    this.selectedProject.deadline_string = utc8String
                    // Convert UTC+8 string to local browser time
                    this.selectedProject.deadline_date = new Date(utc8String).getTime()

                    console.log('4'+this.selectedProject.deadline_date)
                    console.log('5'+new Date().getTime())
                }
            }).catch((err) => {
                console.error('Error fetching project info:', err)
            })
        },
        checkShowOthersView(){
            for(let i=0;i<this.form.curriculum_types.length;i++){
                if(this.form.curriculum_types[i] == 'Others'){
                    return true
                }
            }
            return false
        },

        requestCounties() {
            getCountries().then((res) => {
                this.countryList = res.data
            })
        },

        fetchExclusivePartners() {
            if (!this.form.project_code) {
                return
            }
            getExclusivePartners(this.form.project_code).then((res) => {
                if (res.data.code === 0) {
                    this.exclusivePartners = res.data.data || []
                }
            }).catch(err => {
                console.error('Failed to fetch exclusive partners:', err)
            })
        },

        handleCountryChanged() {
            this.checkExclusivePartner(this.form.account_country)
        },

        checkExclusivePartner(country) {
            const partner = this.exclusivePartners.find(p => p.country === country)
            if (partner && partner.account_info) {
                const message = `Notice: ${partner.account_info.account_name || partner.account_info.account_nameEN} is the exclusive partner in ${country}. You need to contact them directly for registration.\n\nContact: ${partner.account_info.admin_email || 'Please visit their website for contact information.'}`
                this.$alert(message, 'Exclusive Partner Notice', {
                    confirmButtonText: 'OK',
                    type: 'warning'
                })
            }
        },

        submit() {
            if (!this.form.project_code) {
                this.$message.error("Please select a project");
                return;
            }

            const partner = this.exclusivePartners.find(p => p.country === this.form.account_country)
            if (partner && partner.account_info) {
                const message = `Cannot submit: ${partner.account_info.account_name || partner.account_info.account_nameEN} is the exclusive partner in ${this.form.account_country}. You need to contact them directly for registration.\n\nContact: ${partner.account_info.admin_email || 'Please visit their website for contact information.'}`
                this.$alert(message, 'Submission Blocked', {
                    confirmButtonText: 'OK',
                    type: 'error'
                })
                return
            }

            if (!this.isAgree) {
                this.$message.warning("You must agree to the statement.");
                return;
            }

            // Check if past deadline
            if (this.selectedProject && this.isDeadlinePassed()) {
                this.$message.error("Registration deadline has passed.");
                return;
            }

            // Institution T&C are agreed on the payment page, not at registration.
            this.form.institution_terms_agreed = 'NO'

            this.$refs.form.validate((val) => {
                if (val) {
                    checkAndConfirmName(this, [
                        { first: this.form.contact_givenName, last: this.form.contact_lastName, label: 'Registrant name' }
                    ]).then(() => {
                        this.showConfirmDialog = true
                    }).catch(() => {})
                }
            });
        },
        doSubmit() {
            saveAccountFormV1(this.form).then((res) => {
                if (res) {
                    this.$confirm("Registration received. We'll first manually validate your organization information and then set up your school and advisor accounts. You will receive an email from us within 3-5 business days with further instructions on how to log into our EAE system, enter students (with your organization's exclusive student registration link) and form teams.", 'Registration Successful', {
                        showCancelButton: false,
                        confirmButtonText: 'OK',
                        type: 'success'
                    })
                }
            });
        }
    }
})
</script>
<style scoped lang="scss">
::-webkit-scrollbar {
    display: none;
}

.accountform {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    box-sizing: border-box;
    margin: 0 auto;
    background-color: white;
    width: 1000px;
    height: 100vh;
    overflow-y: auto;
    box-shadow: 0 2px 5px 1px rgba(124, 124, 124, 0.2);
    position: relative;

    /deep/ .el-input__inner,
    /deep/ .el-textarea__inner {
        border-color: var(--am-accent, #FF8C00);
    }

    /deep/ .el-input__inner:focus,
    /deep/ .el-textarea__inner:focus {
        border-color: var(--am-accent, #FF8C00);
    }

    .submit .submitBtn {
        background: var(--am-accent, #FF8C00) !important;
    }

    .title1 {
        margin-top: 30px;
        font-family: GravityBold;
        color: #2C3E50;
        font-size: 22px;
        align-items: center;
        width: 100%;
        font-weight: bold;
        text-align: center;
    }

    .row {
        display: flex;
        justify-content: space-between;

        .item {
            width: 420px;
            margin-left: 20px;

            .label {
                font-size: 16px;
                font-family: GravityNormal;
                font-weight: normal;
                color: #666666;
            }

            .input {
                width: 100%;
                display: flex;
                align-items: center;
                font-size: 18px;

                font-family: GravityNormal;
                font-weight: normal;
                color: #333333;

                img {
                    margin-right: 24px;
                    cursor: pointer;
                }
            }
        }
    }

    .project-selection-row,
    .participation-arrangement-row {
        align-items: flex-start;
    }

    .participation-arrangement-row .participation-arrangement-item {
        width: 100%;
        flex: 1 1 100%;
    }

    .el-checkbox-group {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
    }

    .el-radio-group {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
    }

    .participation-radio-group {
        width: 100%;
        gap: 12px;
        flex-wrap: nowrap;
    }

    .participation-radio-option {
        flex: 1;
        min-width: 0;
        min-height: 58px;
        margin-right: 0;
        padding: 10px 12px;
        border: 1px solid #DDE6F1;
        border-radius: 6px;
        box-sizing: border-box;
        background: #FFFFFF;
        line-height: 18px;
        display: flex;
        align-items: flex-start;
    }

    .submit {
        .submitBtn {
            font-family: GravityBold;
            width: 280px;
            height: 50px;
            background: #2C3E50;
            border-radius: 25px;
            text-align: center;
            line-height: 50px;
            color: #fff;
            font-size: 20px;
            margin: 0 auto;
            margin-top: 20px;
            cursor: pointer;
        }

        margin-bottom: 50px;
    }
}


/deep/ .el-input__inner {
    height: 36px;
    line-height: 36px;
    border-color: var(--am-accent, #2C3E50);
}

/deep/ .el-input__inner:hover {
    border-color: var(--am-accent, #2C3E50);
}

/deep/ .el-input__inner:focus {
    border-color: var(--am-accent, #2C3E50);
}

/deep/ .el-form-item__label {
    font-size: 16px;
    color: #000000;
}

/deep/ .el-checkbox__label {
    font-size: 16px;
    color: #000000;
    font-weight: normal;
}

/deep/ .el-radio__label {
    font-size: 16px;
    color: #000000;
    font-weight: normal;
}

/deep/ .participation-radio-option .el-radio__label {
    white-space: normal;
    line-height: 18px;
}

/deep/ .participation-radio-option.is-checked {
    border-color: #2C3E50;
}

/deep/ .participation-radio-option.is-disabled {
    background: #F7FAFC;
}

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #2C3E50;
    border-color: #2C3E50;
}

/deep/ .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #2C3E50;
}

/deep/ .el-radio__input.is-checked .el-radio__inner {
    background-color: #2C3E50;
    border-color: #2C3E50;
}

/deep/ .el-radio__input.is-checked+.el-radio__label {
    color: #2C3E50;
}
</style>
